export type MapBackground = {
    id: string;
    name: string;
    url: string;
};

export const blankMapBackgrounds: string[] = ["blank", "blank map"];
